import TestsQuestions from "@/store/modules/tests/tests-questions";

export default {
  namespaced: true,
  modules: {
    TestsQuestions
  }
};
